import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  // baseURL = "http://localhost/2020/si/api/";

  // baseURL = "http://ninoxsoftsolutions.xyz/demos/billing/api/";

  baseURL="https://suganyaindustries.in/api/";
  
  // baseURL="https://suganyaindustries.online/api/";

  //Bank API method details

  addBank = "bank";
  updateBank = "bank";
  getBank = "bank?get=bank";
  deleteBank = "bank?delete=bank&id={ID}";

  getAllProducts = "products?get=products";


  //Product API method details

  addProduct = "products";
  updateProduct = "products";
  getProduct = "products?get=products";
  deleteProduct = "products?delete=products&id={ID}";

  //Customer API method details
  addCustomer = "customer";
  updateCustomer = "customer";
  getCustomer = "customer?get=customer";
  deleteCustomer = "customer?delete=customer&id={ID}";


  addOrder = "orders.php";
  updateOrder = "orders.php";
  getAllOrders = "orders.php?get=orders";
  getLastOrderID = "orders.php?get=orderID";


  getRupeesInWords = "rupees?get=rupees&amount={total}";



  constructor() { }
}
